import request from "utils/request";

export async function getPrivateNetworks() {
	return request("/rest/private_networks");
}

export async function createPrivateNetwork(payload) {
	return request("/rest/private_networks", {
		method: "PUT",
		body: payload
	});
}

export async function renamePrivateNetwork(payload) {
	return request("/rest/private_networks", {
		method: "POST",
		body: payload
	});
}

export async function deletePrivateNetworks(ids) {
	return request("/rest/private_networks", {
		method: "DELETE",
		body: ids
	});
}

export async function getPrivateNetwork(id) {
	return request("/rest/private_network/" + id);
}

//Payload is in the form
// {
// 	group: "Private",
// 	siteId: "wordpress.com",
// 	email: "seo@gmail.com"
// }
export async function deletePrivateSites(privateNetworkId, payload) {
	return request("/rest/private_network/" + privateNetworkId, {
		method: "DELETE",
		body: payload
	})
}

export async function importPrivateSites(privateNetworkId, payload) {
	return request("/rest/private_network_bulk_upload/" + privateNetworkId, {
		method: "PUT",
		body: payload
	})
}

export async function importPrivateSitesFromAccountProfile(privateNetworkId, payload) {
	return request("/action/import/private_network/" + privateNetworkId, {
		method: "POST",
		body: payload
	});
}